//export const BaseUrl = "http://localhost:1234";
//export const BaseUrl = "https://winstoncellars.z8.web.core.windows.net/";
//export const BaseUrl = "https://retailcartapp.z8.web.core.windows.net";
//export const BaseUrl = "https://shop.winstoncellars.com.au";
export const BaseUrl = "https://winstoncellarstest.z26.web.core.windows.net";
//export const ApiUrl = "http://localhost:7196";
export const ApiUrl = "https://beercollective-dev.azurewebsites.net";
//export const ApiUrl = "https://retailcart.azurewebsites.net";
